




















import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component
export default class ConfirmDeleteDialog extends Vue {
    @Prop() header!: string;
    @Prop() question!: string;
    @Emit() confirm(e: boolean) {
        return e;
    }
}
